const adaptFrecuenciaProfesional = (frecuencia) => {

  return {
    id: frecuencia.idFrecuenciaProfesional,
    displayName: frecuencia.descripccion,
    valor: frecuencia.idFrecuenciaProfesional
  };
};

export const adaptFrecuenciasProfesionales = (data) => {
  const adaptedData = data?.frecuenciasProfesionales?.map((frecuencia) =>
    adaptFrecuenciaProfesional(frecuencia)
  );

  return adaptedData;
};
